var map = {
	"./aprilia-pin.png": "d828",
	"./derbi-pin.png": "1311",
	"./gilera-pin.png": "b1ab",
	"./moto-guzzi-pin.png": "e1bd",
	"./piaggio-pin.png": "d417",
	"./piaggiocommercial-pin.png": "0050",
	"./scarabeo-pin.png": "b1b7",
	"./vespa-pin.png": "fc7d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af7d";